import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    flight_control: getDefaultAsyncWrapperObj(),
    groups: getDefaultAsyncWrapperObj(),
    isolation_groups: getDefaultAsyncWrapperObj(),
    flight_configurations: getDefaultAsyncWrapperObj(),
    flights_dictionary: getDefaultAsyncWrapperObj(),
};
const prefix = 'FLIGHT_CREATE';
export const createLoaderActionTypes = (resource) => ({
    LOAD: `${prefix}/${resource}/LOAD`,
    LOADING: `${prefix}/${resource}/LOADING`,
    LOADED: `${prefix}/${resource}/LOADED`,
});
export const managementGroupsActionTypes = createLoaderActionTypes('MANAGEMENT_GROUPS');
export const flightControlActionTypes = createLoaderActionTypes('FLIGHT_CONTROL');
export const validateFlightsActionTypes = createLoaderActionTypes('VALIDATE_FLIGHTS');
export const createFlightActionTypes = createLoaderActionTypes('CREATE_FLIGHTS');
export const loadManagementGroups = (workspaceId, managementGroup) => {
    return {
        type: managementGroupsActionTypes.LOAD,
        payload: {
            workspaceId,
            managementGroup,
        },
    };
};
export const loadingManagementGroups = () => {
    return {
        type: managementGroupsActionTypes.LOADING,
        payload: {
            groups: {
                data: null,
                status: AsyncRequestStatus.Pending,
            },
        },
    };
};
export const loadedManagementGroups = (groups) => {
    return {
        type: managementGroupsActionTypes.LOADED,
        payload: {
            groups,
        },
    };
};
export const loadFlightControl = (workspaceId, managementGroup) => {
    return {
        type: flightControlActionTypes.LOAD,
        payload: {
            managementGroup,
            workspaceId,
        },
    };
};
export const loadingFlightControl = (payload) => {
    return {
        type: flightControlActionTypes.LOADING,
        payload: {
            flight_control: {
                data: null,
                status: AsyncRequestStatus.Pending,
            },
        },
    };
};
export const loadedFlightControl = (payload) => {
    return {
        type: flightControlActionTypes.LOADED,
        payload: {
            flight_control: payload,
        },
    };
};
export const validateFlights = (payload) => {
    return {
        type: validateFlightsActionTypes.LOAD,
        payload,
    };
};
export const validatingFlights = (payload) => {
    return {
        type: validateFlightsActionTypes.LOADING,
        payload: {
            flights_dictionary: {
                data: null,
                status: AsyncRequestStatus.Pending,
            },
        },
    };
};
export const validatedFlights = (payload) => {
    return {
        type: validateFlightsActionTypes.LOADED,
        payload: {
            flights_dictionary: payload,
        },
    };
};
export const createFlights = (payload) => {
    return {
        type: createFlightActionTypes.LOAD,
        payload,
    };
};
export const creatingFlights = (payload) => {
    return {
        type: createFlightActionTypes.LOADING,
        payload: {
            flight_configurations: {
                data: null,
                status: AsyncRequestStatus.Pending,
            },
        },
    };
};
export const flightsCreated = (payload) => {
    return {
        type: createFlightActionTypes.LOADED,
        payload: {
            flight_configurations: payload,
        },
    };
};
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case managementGroupsActionTypes.LOADING:
        case managementGroupsActionTypes.LOADED:
        case flightControlActionTypes.LOADING:
        case flightControlActionTypes.LOADED:
        case createFlightActionTypes.LOADING:
        case createFlightActionTypes.LOADED:
        case validateFlightsActionTypes.LOADING:
        case validateFlightsActionTypes.LOADED:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=CreateContainer.ducks.js.map
